import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap justify-between items-center" }
const _hoisted_2 = { class: "flex flex-nowrap md:flex-wrap gap-2 md:gap-5 overflow-x-auto pb-1 md:pb-0 md:overflow-visible" }
const _hoisted_3 = {
  key: 13,
  class: "ml-2 flex"
}
const _hoisted_4 = { class: "flex flex-wrap gap-2 text-sm font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filter_btn = _resolveComponent("filter-btn")!
  const _component_filters_vue = _resolveComponent("filters-vue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.dateFilter)
        ? (_openBlock(), _createBlock(_component_filter_btn, {
            key: 0,
            text: $setup.dateFilter.text,
            shouldRemove: false
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.unitsFilter, (unit) => {
        return (_openBlock(), _createBlock(_component_filter_btn, {
          key: unit.text,
          text: unit?.text,
          onOnRemove: ($event: any) => ($setup.removeUnitsFilter(unit?.id))
        }, null, 8, ["text", "onOnRemove"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hoursFilter, (hour) => {
        return (_openBlock(), _createBlock(_component_filter_btn, {
          key: hour.text,
          text: hour?.text,
          onOnRemove: ($event: any) => ($setup.removeHoursFilter(hour.text))
        }, null, 8, ["text", "onOnRemove"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.schedulesFilter, (schedule) => {
        return (_openBlock(), _createBlock(_component_filter_btn, {
          key: schedule.text,
          text: schedule?.text,
          onOnRemove: ($event: any) => ($setup.removeSchedulesFilter(schedule?.id))
        }, null, 8, ["text", "onOnRemove"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sectorSpecialtyChips, (chip) => {
        return (_openBlock(), _createBlock(_component_filter_btn, {
          key: chip.key,
          text: chip.text,
          onOnRemove: ($event: any) => ($setup.removeSectorSpecialtyChip(chip))
        }, null, 8, ["text", "onOnRemove"]))
      }), 128)),
      ($setup.valueFilter)
        ? (_openBlock(), _createBlock(_component_filter_btn, {
            key: 1,
            text: $setup.valueFilter,
            onOnRemove: $setup.removeValueFilter
          }, null, 8, ["text", "onOnRemove"]))
        : _createCommentVNode("", true),
      ($setup.paymentValueFilter)
        ? (_openBlock(), _createBlock(_component_filter_btn, {
            key: 2,
            text: $setup.paymentValueFilter,
            onOnRemove: $setup.removePaymentValueFilter
          }, null, 8, ["text", "onOnRemove"]))
        : _createCommentVNode("", true),
      ($setup.checkinFilter)
        ? (_openBlock(), _createBlock(_component_filter_btn, {
            key: 3,
            text: $setup.checkinFilter,
            onOnRemove: $setup.removeCheckinFilter
          }, null, 8, ["text", "onOnRemove"]))
        : _createCommentVNode("", true),
      ($setup.checkoutFilter)
        ? (_openBlock(), _createBlock(_component_filter_btn, {
            key: 4,
            text: $setup.checkoutFilter,
            onOnRemove: $setup.removeCheckoutFilter
          }, null, 8, ["text", "onOnRemove"]))
        : _createCommentVNode("", true),
      ($setup.inCashFilter)
        ? (_openBlock(), _createBlock(_component_filter_btn, {
            key: 5,
            text: $setup.inCashFilter,
            onOnRemove: $setup.removeInCashFilter
          }, null, 8, ["text", "onOnRemove"]))
        : _createCommentVNode("", true),
      ($setup.advanceRequestedFilter)
        ? (_openBlock(), _createBlock(_component_filter_btn, {
            key: 6,
            text: $setup.advanceRequestedFilter,
            onOnRemove: $setup.removeAdvanceRequestedFilter
          }, null, 8, ["text", "onOnRemove"]))
        : _createCommentVNode("", true),
      ($setup.advancePaidFilter)
        ? (_openBlock(), _createBlock(_component_filter_btn, {
            key: 7,
            text: $setup.advancePaidFilter,
            onOnRemove: $setup.removeAdvancePaidFilter
          }, null, 8, ["text", "onOnRemove"]))
        : _createCommentVNode("", true),
      ($setup.statusFilter)
        ? (_openBlock(), _createBlock(_component_filter_btn, {
            key: 8,
            text: $setup.statusFilter,
            onOnRemove: $setup.removeStatusFilter
          }, null, 8, ["text", "onOnRemove"]))
        : _createCommentVNode("", true),
      ($setup.stationTypeFilter)
        ? (_openBlock(), _createBlock(_component_filter_btn, {
            key: 9,
            text: $setup.stationTypeFilter,
            onOnRemove: $setup.removeStationTypeFilter
          }, null, 8, ["text", "onOnRemove"]))
        : _createCommentVNode("", true),
      ($setup.ourTeamFilter)
        ? (_openBlock(), _createBlock(_component_filter_btn, {
            key: 10,
            text: $setup.ourTeamFilter,
            onOnRemove: $setup.removeOurTeamFilter
          }, null, 8, ["text", "onOnRemove"]))
        : _createCommentVNode("", true),
      ($setup.openedStationFilter)
        ? (_openBlock(), _createBlock(_component_filter_btn, {
            key: 11,
            text: $setup.openedStationFilter,
            onOnRemove: $setup.removeOpenedStationFilter
          }, null, 8, ["text", "onOnRemove"]))
        : _createCommentVNode("", true),
      ($setup.coverageStatusFilter)
        ? (_openBlock(), _createBlock(_component_filter_btn, {
            key: 12,
            text: $setup.coverageStatusFilter,
            "data-testid": "dashboard-coverage-status-chip",
            onOnRemove: $setup.removeCoverageStatusFilter
          }, null, 8, ["text", "onOnRemove"]))
        : _createCommentVNode("", true),
      ($setup.hasActiveFilters)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.clearAllFilters && $setup.clearAllFilters(...args))),
              class: "text-sm font-bold text-primary hover:text-primary-darken-1 transition-colors"
            }, " Limpar filtros ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_filters_vue)
    ])
  ]))
}